import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

import { LinkToPayState } from './types';
import { RootState } from '@/store/types';

const namespaced = true;

export const state: LinkToPayState = {
  payment: null,
  isLoading: true,
  errorMessages: [],
  paypalData: null
};

export const linkToPay: Module<LinkToPayState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};